import { CanvasJSChart } from 'app/components/CanvasJs';
import React from 'react';
import { coresGestaoEnvio } from './styles';

const GestaoEnvioGraficoSituacao = ({ values }) => {
  return (
    <CanvasJSChart
      options={{
        culture: 'pt-br',
        animationEnabled: true,
        axisY: {
          labelFontSize: 11,
        },
        toolTip: {
          shared: true,
        },
        legend: {
          fontSize: 16,
          cursor: 'pointer',
          verticalAlign: 'bottom',
        },
        data: [
          {
            type: 'pie',
            showInLegend: true,
            dataPoints: [
              {
                y: values.somatorioErro || 0,
                color: coresGestaoEnvio.vermelho,
                legendText: 'Erro',
              },
              {
                y: values.somatorioEnviado || 0,
                color: coresGestaoEnvio.verde,
                legendText: 'Enviados',
              },
              {
                y: values.somatorioVisualizado || 0,
                color: coresGestaoEnvio.azul,
                legendText: 'Visualizados',
              },
            ],
          },
        ],
      }}
    />
  );
};

export default GestaoEnvioGraficoSituacao;
